import type { UnknownAction } from "@reduxjs/toolkit"
import type { AppDispatch } from "../../../../store"
import { assetViewSlice } from "./asset-view-slice"
import { factorsViewSlice } from "./factors-view-slice"
import { graphSlice } from "./graph-slice"
import { kpiSlice } from "./kpi-slice"
import { getPanelIdForModule } from "../helpers/module-renderers"
import { MODULE_TYPES, type ModuleType, type DashboardModule } from "../modules/types"

type RemovePanelAction = (args: { dashboardId: string, panelId: string }) => UnknownAction

// removePanel per module type. Partial — types without a panel slice (ai-artifact) are skipped.
const REMOVE_PANEL_BY_TYPE: Partial<Record<ModuleType, RemovePanelAction>> = {
  [MODULE_TYPES.ASSET_VIEW]: assetViewSlice.actions.removePanel,
  [MODULE_TYPES.FACTORS]: factorsViewSlice.actions.removePanel,
  [MODULE_TYPES.GRAPH]: graphSlice.actions.removePanel,
  [MODULE_TYPES.KPI]: kpiSlice.actions.removePanel,
}

// Frees a module's per-panel slot on removal. Caller owns the panels-slice + event ordering.
export function cleanupPanelSlices(
  dispatch: AppDispatch,
  dashboardId: string,
  module: DashboardModule,
): void {
  const removePanel = REMOVE_PANEL_BY_TYPE[module.type]
  if (!removePanel) return
  dispatch(removePanel({ dashboardId, panelId: getPanelIdForModule(module) }))
}
